import { ClickType, ElementType } from '@fiverr-private/bianka_js';
import { getContext } from '@fiverr-private/fiverr_context';
import { AdditionalData, bianka } from '@fiverr-private/obs';
import { Click } from '@fiverr-private/bianka_js/protobuf/bianka/event/activity/v2/click';
import { Impression } from '@fiverr-private/bianka_js/protobuf/bianka/event/activity/v2/impression';
import { PAGE_NAME } from '../consts';

type AdditionalDataValues = Record<string, any>;

export interface ClickEventPropsBase {
    sellerId: string;
    eventName: string;
    componentType: ElementType;
    componentName: string;
    componentLabel: string;
}

interface AdditionalDataProps<T extends AdditionalDataValues> {
    additionalData?: AdditionalData<T>;
}

export const reportClickBase = <T extends AdditionalDataValues>({
    sellerId,
    eventName,
    componentType,
    componentName,
    componentLabel,
    additionalData,
}: ClickEventPropsBase & AdditionalDataProps<T>) => {
    const { pageCtxId } = getContext();

    bianka.reportActivity<Click, T>({
        type: Click,
        event: {
            type: eventName,
            page: {
                name: PAGE_NAME,
                ctxId: pageCtxId,
            },
            clickType: ClickType.UNSPECIFIED,
            seller: {
                id: Number(sellerId),
            },
            element: {
                name: componentName,
                type: componentType,
                text: { value: componentLabel },
                numberOfElements: 1,
            },
        },
        additionalData,
    });
};

export interface ImpEventPropsBase {
    sellerId: string;
    eventName: string;
    componentType: string;
    componentName: string;
    componentLabel: string;
}

export const reportImpressionBase = <T extends AdditionalDataValues>({
    sellerId,
    eventName,
    componentType,
    componentName,
    componentLabel,
    additionalData,
}: ImpEventPropsBase & AdditionalDataProps<T>) => {
    const { pageCtxId } = getContext();

    bianka.reportActivity<Impression, T>({
        type: Impression,
        event: {
            type: eventName,
            page: {
                name: PAGE_NAME,
                ctxId: pageCtxId,
            },
            seller: {
                id: Number(sellerId),
            },
            component: {
                impId: Date.now().toString(),
                level: 1,
                isLeaf: false,
                positionInParent: 1,
                numberOfElements: 1,
                sizeInParent: 1,
                visibleThroughScroll: true,
                name: componentName,
                type: componentType,
                text: componentLabel,
            },
        },
        additionalData,
    });
};
